import React, { useContext, useEffect, useRef, useState } from 'react'
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from '../../../../bootstrap/Card'
import Icon from "../../../../icon/Icon"
import Input from "../../../../bootstrap/forms/Input"
import useSortableData from '../../../../../hooks/useSortableData'
import PaginationButtons, { dataPagination } from '../../../../PaginationButtons'
import { toasts } from '../../../../../services/toast.service'
import { useFormik } from 'formik'
import Page from '../../../../../layout/Page/Page'
import Button, { ButtonGroup } from '../../../../bootstrap/Button'
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from "../../../../bootstrap/Modal";
import PageWrapper from '../../../../../layout/PageWrapper/PageWrapper'
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../../../bootstrap/Dropdown'
import FormGroup from '../../../../bootstrap/forms/FormGroup'
import Checks, { ChecksGroup } from '../../../../bootstrap/forms/Checks'
import { convertJsonToPdf, downloadExcel, downloadFile } from '../../../../../services/ExportService'
import { useReactToPrint } from 'react-to-print'
import AuthContext from '../../../../../contexts/authContext'
import { getColumnsForDataTable, getCurrentDateAndTime, updateColumnsForDataTable, updateFilter } from '../../../../../services/common.service'
import { getLicenseKey } from '../../../../../services/application.settings'
import { approveTcDetailsByHod, getTcListForApprovedByStaffDetailsId } from '../../../../../services/certificate.service'
import { TableLoader, showLoader } from '../../../../../services/loader.services'
import AlertService from '../../../../../services/AlertService'
import SubHeader, { SubHeaderLeft } from '../../../../../layout/SubHeader/SubHeader'
import dayjs from 'dayjs'
import NoDataMsg from '../../../../../common/components/NoDataMsg'

function StudentTcApprovel() {

    useEffect(() => {
        getTcListForApprovedByStaff(userAccountId)
    }, [])

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const [studentTcApprovelData, setStudentTcApprovelData] = useState<any>([])
    const [editStudentTcApprovelModal, setEditStudentTcApprovelModal] = useState(false)
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const componentRef = useRef(null);
    const { items, requestSort, getClassNamesFor } = useSortableData(studentTcApprovelData);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);
    const [columnDataById, setColumnDataById] = useState([])
    const [columnVisibilityMenu, setColumnVisibilityMenu] = useState(false);
    const [allColumnsData, setAllColumnsData] = useState([]);
    const [columnVisibilityData, setColumnVisibilityData] = useState([]);
    const [isChecked, setIsChecked] = useState(false)
    const [dataStatus, setDataStatus] = useState(false)
    const [todayApprovalCount, setTodayApprovalCount] = useState(0)
    const [noDataMsg, setNoDataMsg] = useState('')

    //For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState(false);

    const columnVisibilityForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },

        //validateOnChange: false,
        onSubmit: () => { },
    });

    // Filter
    const filteredData = updateFilter(onCurrentPageData, columnVisibilityData, columnVisibilityForm);

    function getTcListForApprovedByStaff(staffDetailsId: any) {
        setDataStatus(false)
        getTcListForApprovedByStaffDetailsId(staffDetailsId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.tcListForApprovedByStaffDetailsId;
                    if (data != undefined) {
                        getColumnsForTable('getTcListForApprovedByStaffDetailsId', 'get');
                        setStudentTcApprovelData(data);
                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                        }
                        setDataStatus(true)
                        setTodayApprovalCount(data.filter((data1: any) => dayjs(new Date(data1.dateStamp)).format('YYYY-MM-DD') === getCurrentDateAndTime('date')).length)

                    } else {
                        setDataStatus(true)
                        setAlertStatus({ message: "Undefined Data", type: "error" });
                        setIsOpen(true);
                    }
                }
                else if (response.data.success === false) {
                    getColumnsForTable('getTcListForApprovedByStaffDetailsId', 'get');
                    setStudentTcApprovelData([]);
                    setDataStatus(true)
                    setNoDataMsg(response.data.message)
                    // setAlertStatus({ message: response.data.message, type: "error" });
                    // setIsOpen(true);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    setDataStatus(true)
                    setAlertStatus({ message: errorDescription, type: "error" });
                    setIsOpen(true);
                }
            }, error => {
                setDataStatus(true)
                setAlertStatus({ message: error, type: "error" });
                setIsOpen(true);
            }
        )
    }

    const approveTcForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            studentDetailsId: '',
            studentTransferCertificateId: '',
            remarks: ''
        },
        validate: (values) => { },

        //validateOnChange: false,
        onSubmit: () => { },
    });

    function onActivate(i: any) {
        if (i != undefined) {

            let selectedTCAction = i
            setEditStudentTcApprovelModal(true)
            approveTcForm.setValues({
                studentDetailsId: selectedTCAction.studentDetailsId,
                studentTransferCertificateId: selectedTCAction.studentTransferCertificateId,
                remarks: selectedTCAction.remarks
            });

        }
    }

    function approveTCDetails() {
        return ({
            licenseKey: getLicenseKey,
            userAccountId: userAccountId,
            studentTransferCertificateId: approveTcForm.values.studentTransferCertificateId,
            statusId: 2,
            remarks: approveTcForm.values.remarks,

        })
    }

    function approveTcSubmit() {
        showLoader(true)
        if (approveTcForm.isValid) {
            let approveTcPostData = approveTCDetails()
            approveTcDetailsByHod(approveTcPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        getTcListForApprovedByStaff(userAccountId)
                        setEditStudentTcApprovelModal(false);
                    }
                    else if (data.success == false) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false)
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }
                , (error) => {
                    showLoader(false)
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                }
            )
        } else if (approveTcForm.isValid == false) {
            showLoader(false)
            setAlertStatus({ message: 'Please fill all the details!', type: "error" });
            setIsOpen(true);
        }
    }

    function getColumnsForTable(apiName: any, type: any) {
        getColumnsForDataTable(userTypeId, apiName,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.columnsForDataTable;
                    if (data != undefined) {
                        let allColumnsData = data;
                        setAllColumnsData(allColumnsData)
                        let columnVisibilityData = allColumnsData.filter((item: any) => item.isDisplay == 1);
                        setColumnVisibilityData(columnVisibilityData)

                        if (type == 'get') {
                            const allData = allColumnsData.map((item: any) => item.isDisplay);
                            const allColumns = allData.filter((item: any) => item == false);
                            setIsChecked(allColumns == '' ? true : false);
                        }
                        else if (type == 'post') {
                            const all = [];
                            let nonDefaultValue = allColumnsData.filter((item: any) => item.isDefault == false)

                            for (let i = 0; i < nonDefaultValue.length; i++) {

                                const obj = {
                                    columnVisibilityId: nonDefaultValue[i].columnVisibilityId,
                                    isDisplay: nonDefaultValue[0].isDisplay == 0 ? 1 : 0
                                }
                                all.push(obj);
                            }
                            updateColumnsSubmit('', '', all)
                        }
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    toasts(response.data.message, "Error")
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )

    }

    function updateColumnsSubmit(columnVisibilityId: any, isDisplay: any, type: any) {

        if (columnVisibilityForm.isValid) {

            setColumnDataById(isDisplay)
            const columnVisibilityPostData = {
                licenseKey: getLicenseKey,
                userAccountId: userAccountId,
                columns: type ? type : [
                    {
                        columnVisibilityId: columnVisibilityId,
                        isDisplay: isDisplay ? 0 : 1
                    }
                ]
            }

            updateColumnsForDataTable(columnVisibilityPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        getColumnsForTable('getTcListForApprovedByStaffDetailsId', 'get');
                    }
                    else if (data.success == false) {
                        // toasts(data.success, "Error")
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        toasts(errorDescription, "Error")
                    }
                }
                , (error) => {
                    toasts(error, "Error")
                }
            )
        } else if (columnVisibilityForm.isValid == false) {
            toasts("Please fill all the details!", "Error")
        }
    }

    function closeModal() {
        setEditStudentTcApprovelModal(false);
        setIsDeleteOpen(false);
    }

    // Excel Configuration
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <PageWrapper title='Student Tc Approval'>
            {studentTcApprovelData != "" ?
                <SubHeader>
                    <SubHeaderLeft>
                        <Icon icon='Info' className='me-2' size='2x' />
                        <span className='text-muted'>
                            You have{' '}
                            <Icon icon='Check Circle ' color='success' className='mx-1' size='lg' /> <span className='fw-bolder'>{studentTcApprovelData.length}{' '}</span>
                            approved appointments and{' '}
                            <Icon icon='pending_actions ' color='danger' className='mx-1' size='lg' /> <span className='fw-bold'>{todayApprovalCount}{' '}</span>
                            pending appointments for today.
                        </span>
                    </SubHeaderLeft>
                </SubHeader> : <></>}
            <Page container='fluid'>
                <Card stretch data-tour='list' ref={componentRef} id='pdf'>

                    <CardHeader borderSize={1}>
                        <CardLabel icon='List' iconColor='info' className="col-lg-6">
                            <CardTitle tag='div' className='h5'>Student Tc Approval</CardTitle>
                        </CardLabel>&nbsp;&nbsp;

                        <ButtonGroup className="col-lg-3 d-print-none" color='primary'>
                            <Icon className="mt-1" icon='Search' size='2x' color='primary' />
                            <Input id='searchInput' type='search' placeholder='Search...' onChange={columnVisibilityForm.handleChange} value={columnVisibilityForm.values.searchInput} />
                        </ButtonGroup>

                        <CardActions className="d-print-none">
                            <Dropdown isOpen={columnVisibilityMenu} setIsOpen={setColumnVisibilityMenu} isButtonGroup>
                                <DropdownToggle>
                                    <Button icon='FilterAlt' color='primary' isLight>Filter</Button>
                                </DropdownToggle>
                                <DropdownMenu isAlignmentEnd size='lg' isCloseAfterLeave={false}>
                                    <DropdownItem>
                                        <div className='container py-2'>
                                            <form className='row g-3'>
                                                <div className='col-12'>
                                                    <FormGroup>
                                                        <h6>Select All</h6>
                                                        <Checks id='available' type='switch' label='Select All Columns' onChange={() => getColumnsForTable('getTcListForApprovedByStaffDetailsId', 'post')} checked={isChecked} ariaLabel='Available status' />
                                                    </FormGroup>
                                                </div>
                                                <div className='col-12' style={{ maxHeight: '200px', overflowY: 'scroll' }}>
                                                    <FormGroup>
                                                        <h6>Columns</h6>
                                                        <ChecksGroup>
                                                            {allColumnsData.map((i: any) => (
                                                                <Checks key={i.columnVisibilityId} id='{i.columnVisibilityId}' label={i.columnName} onChange={() => updateColumnsSubmit(i.columnVisibilityId, i.isDisplay, '')} checked={i.isDisplay} disabled={i.isDefault == true} />
                                                            ))}
                                                        </ChecksGroup>
                                                    </FormGroup>
                                                </div>
                                            </form>
                                        </div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            <Dropdown isButtonGroup>
                                <DropdownToggle>
                                    <Button color='primary' isLight icon='CloudDownload'> Export </Button>
                                </DropdownToggle>
                                <DropdownMenu isAlignmentEnd>
                                    <DropdownItem>
                                        <Button color='primary' isLight icon='CloudDownload' onClick={() => downloadExcel("Student Tc Approval", studentTcApprovelData, columnVisibilityData)}> Excel </Button>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <Button color='primary' isLight icon='PictureAsPdf' onClick={() => convertJsonToPdf(studentTcApprovelData, columnVisibilityData, "Student Tc Approval")}> PDF
                                        </Button>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <Button color='primary' isLight icon='CloudDownload' onClick={() => downloadFile("Student Tc Approval", studentTcApprovelData, columnVisibilityData)}> CSV </Button>
                                    </DropdownItem>
                                    <DropdownItem>
                                        <Button color='primary' isLight icon='Print' onClick={handlePrint}> Print </Button>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </CardActions>
                    </CardHeader>

                    <CardBody className='table-responsive' isScrollable>
                        {!dataStatus ?
                            <TableLoader /> :
                            <table className='table table-modern table-hover text-nowrap'>
                                <thead>
                                    <tr>
                                        <th scope='col' onClick={() => requestSort('sno')}
                                            className='cursor-pointer text-decoration-underline'>S.No{' '}
                                            <Icon size='lg' className={getClassNamesFor('sno')} icon='FilterList' />
                                        </th>
                                        {columnVisibilityData.map((column: any) => (
                                            <th key={column.keyName} scope='col' onClick={() => requestSort(column.keyName)}
                                                className='cursor-pointer text-decoration-underline'>
                                                {column.columnName}
                                                <Icon size='lg' className={getClassNamesFor(column.keyName)} icon='FilterList' />
                                            </th>
                                        ))}
                                        <th scope='col' className='d-print-none'>
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData != "" ?
                                        <>
                                            {filteredData.map((rowData: any) => (
                                                <tr key={rowData.studentTransferCertificateId}>
                                                    <td>{rowData.sno}</td>
                                                    {columnVisibilityData.map((column: any) => (
                                                        (column.isDisplay && rowData[column.keyName]) ?
                                                            <td key={`${rowData.studentTransferCertificateId}-${column.keyName}`}>{rowData[column.keyName]}</td> : <td key={`empty-${column.keyName}`} />
                                                    ))}
                                                    <td className="d-print-none" >
                                                        <Button color='dark' isLight icon='Edit' aria-label='Edit' onClick={() => { onActivate(rowData) }} /></td>
                                                </tr>
                                            ))
                                            }</>
                                        :
                                        <NoDataMsg columnsCount={columnVisibilityData.length + 2} msg={noDataMsg}/>}
                                </tbody>
                            </table>
                        }
                    </CardBody>
                    <PaginationButtons
                        className='d-print-none'
                        data={items}
                        label='items'
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage}
                        perPage={perPage}
                        setPerPage={setPerPage}
                    />
                </Card>
            </Page>

            <Modal
                setIsOpen={setEditStudentTcApprovelModal}
                isOpen={editStudentTcApprovelModal}
                titleId='editStudentTcApprovelModal'

                isStaticBackdrop
                size='sm'
            // fullScreen='sm'
            >
                <ModalHeader className="'modal-header'"
                    setIsOpen={() => { setEditStudentTcApprovelModal(false) }} onClick={closeModal}>
                    <ModalTitle id="editStudentTcApprovelModal">Approved On</ModalTitle>
                </ModalHeader>
                <ModalBody >
                    {/* <div className="row g-4 ">
                        <div className="col-12 d-flex justify-content-center">
                            <h5><strong>{getCurrentDateAndTime('dateAndTime')}</strong></h5>
                        </div>                       
                    </div> */}

                    <div className='row align-middle'>
                        {/* <p className="text-primary mg-b-20">Approved On : {getCurrentDateAndTime('dateAndTime')}</p> */}
                        <h5 className="main-content-label mb-1 text-center text-danger">{getCurrentDateAndTime('dateAndTime')}</h5>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color='info' isOutline className='border-0' onClick={closeModal}>Close</Button>
                    <Button color='success' icon='CheckCircleOutline' onClick={() => { approveTcSubmit() }}>Approve </Button>
                </ModalFooter>
            </Modal>

            <AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} />
        </PageWrapper>
    )
}

export default StudentTcApprovel
